import(/* webpackMode: "eager", webpackExports: ["CustomerProjectForm"] */ "/vercel/path0/apps/frontend/src/app/[lang]/(default)/(auth)/customer/projects/CreateCustomerProjectForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClientLoginForm"] */ "/vercel/path0/apps/frontend/src/app/[lang]/(default)/(guest)/customer/account/(multicolumn)/login/Form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProseImage"] */ "/vercel/path0/apps/frontend/src/app/[lang]/(default)/page/[type]/[id]/ProseImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LegacyCartConverter"] */ "/vercel/path0/apps/frontend/src/app/[lang]/cart/LegacyCartConverter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PostCodeForm"] */ "/vercel/path0/apps/frontend/src/app/[lang]/cart/PostCodeForm.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/frontend/src/app/[lang]/command/ActiveDialog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ImportDropdownWrapper"] */ "/vercel/path0/apps/frontend/src/app/[lang]/command/dialogs/import/Dropdowns.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ImportForm"] */ "/vercel/path0/apps/frontend/src/app/[lang]/command/dialogs/import/Form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ImportFormInputs"] */ "/vercel/path0/apps/frontend/src/app/[lang]/command/dialogs/import/FormInputs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ImportTabs"] */ "/vercel/path0/apps/frontend/src/app/[lang]/command/dialogs/import/Tabs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CommandInner"] */ "/vercel/path0/apps/frontend/src/app/[lang]/command/Inner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CommandItemuseBoards","CommandItemCart"] */ "/vercel/path0/apps/frontend/src/app/[lang]/command/pages/items/Cart.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SimpleCommandItemProduct","FurnitureProductWrapper","CommandItemDispatchEvent"] */ "/vercel/path0/apps/frontend/src/app/[lang]/command/pages/items/Product.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguagePage"] */ "/vercel/path0/apps/frontend/src/app/[lang]/command/pages/Language.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CommandProvider"] */ "/vercel/path0/apps/frontend/src/app/[lang]/command/Provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CommandInput"] */ "/vercel/path0/apps/frontend/src/app/[lang]/command/utils/CommandInput.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CommandDialog"] */ "/vercel/path0/apps/frontend/src/app/[lang]/command/utils/Dialog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CommandEmpty"] */ "/vercel/path0/apps/frontend/src/app/[lang]/command/utils/Empty.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/frontend/src/app/[lang]/command/utils/Group.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/frontend/src/app/[lang]/command/utils/Item.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RenderCommandDialogs"] */ "/vercel/path0/apps/frontend/src/app/[lang]/command/utils/Render.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/frontend/src/app/[lang]/command/Wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/frontend/src/app/[lang]/CookieConsent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GoogleTagManagerInit","GoogleTagManagerScript"] */ "/vercel/path0/apps/frontend/src/app/[lang]/GoogleTagManager.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BackToTop"] */ "/vercel/path0/apps/frontend/src/app/[lang]/overlay/BackToTop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BackToTopProvider"] */ "/vercel/path0/apps/frontend/src/app/[lang]/overlay/BackToTopProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FilterButton"] */ "/vercel/path0/apps/frontend/src/app/[lang]/overlay/FilterButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ChatShortLink"] */ "/vercel/path0/apps/frontend/src/app/[lang]/overlay/service/ServiceButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ServiceButtonRenderer"] */ "/vercel/path0/apps/frontend/src/app/[lang]/overlay/service/ServiceButtonRenderer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ServiceContentSelector"] */ "/vercel/path0/apps/frontend/src/app/[lang]/overlay/service/ServiceContentSelector.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NProgressComponent"] */ "/vercel/path0/apps/frontend/src/app/[lang]/Progress.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClientProviders"] */ "/vercel/path0/apps/frontend/src/app/[lang]/providers/ClientProviders.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LocaleProvider"] */ "/vercel/path0/apps/frontend/src/app/[lang]/providers/LocaleProvider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/frontend/src/app/ErrorBoundary.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/frontend/src/components/Link.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/@fortawesome+fontawesome-svg-core@6.7.2/node_modules/@fortawesome/fontawesome-svg-core/styles.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.3.1_@babel+core@7.26.10_@playwright+test@1.52.0_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.3.1_@babel+core@7.26.10_@playwright+test@1.52.0_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/font/google/target.css?{\"path\":\"src/styles/font.ts\",\"import\":\"Lato\",\"arguments\":[{\"preload\":true,\"display\":\"fallback\",\"subsets\":[\"latin\"],\"weight\":[\"400\",\"700\",\"900\"],\"variable\":\"--secondary-font\"}],\"variableName\":\"lato\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/frontend/src/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/src/components/Alert.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/src/components/ContactButton.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/src/components/dialog/Context.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/src/components/dialog/Default.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/src/components/dialog/DialogButton.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/src/components/dialog/fix.ts");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/src/components/dialog/Overlay.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/src/components/dialog/Side.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/src/components/Edgeband.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/src/components/FilterButton.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/src/components/form/Checkbox.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/src/components/form/DataList.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/src/components/form/DateSelector.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/src/components/form/FileInput.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/src/components/form/FileInputWithVisual.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/src/components/form/Input.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/src/components/form/MultiSelect.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/src/components/form/native/NativeInput.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/src/components/form/native/NativeNumberInput.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/src/components/form/radio-group/RadioGroup.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/src/components/form/radio-group/RadioGroupItem.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/src/components/form/Radio.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/src/components/form/RadixSelect.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/src/components/form/Select.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/src/components/form/TextArea.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/src/components/form/utilities/Form.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/src/components/form/utilities/zodForm.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/src/components/interactive/Anchor.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/src/components/interactive/Button.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/src/components/interactive/custom/Circle.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/src/components/interactive/custom/DropDownButton.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/src/components/interactive/custom/Square.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/src/components/Popover.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/src/components/service/Tags.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/src/components/Sticky.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/src/components/switch/Switch.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/src/components/toast/Component.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/src/components/Tooltip.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/src/components/Video.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/src/content/Error.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/src/context/NotificationContext.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/src/context/NotificationProvider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/src/context/PageVariantContext.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/src/context/PageVariantProvider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/src/context/ServiceContext.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/src/context/ServiceProvider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/src/hooks/useClient.ts");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/src/hooks/useKeydown.ts");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/src/hooks/useLongPress.ts");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/src/hooks/useModal.ts");
